export default __webpack_public_path__ + "static/media/service-02.906f4108.jpg";